
// 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/esm/Row';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom';
// import { Notify } from '../../Utility/Notify';
// import { GetOneRegionsData, UpdateOneRegionData } from '../../Redux/Actions/Regions_Action';
// // import AddIcon from '@mui/icons-material/Add';
// import SyncAltIcon from '@mui/icons-material/SyncAlt';
// import { Col } from 'react-bootstrap';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material';

// export const UpdateRegions = () => {
//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const [regions, setregions] = useState('');
//   const [loading, setloading] = useState(true);

//   // get one region to update ===============================================
//   useEffect(() => {
//     const run = async () => {
//       await dispatch(GetOneRegionsData(id));
//     };
//     run();
//   }, [dispatch]);

//   const res_one_region = useSelector((state) => state.AllRegions.Region);

//   let one_region = [];
//   if (res_one_region && res_one_region.data) {
//     one_region = res_one_region.data;
//   } else {
//     one_region = [];
//   }

//   useEffect(() => {
//     if (one_region) {
//       setregions(one_region.name);
//     }
//   }, [one_region]);
//   // ====================================================================update region

//   const namechange = (e) => {
//     setregions(e.target.value);
//   };
//   const updateregion = async (e) => {
//     if (regions === '') {
//       Notify('error', 'Please Enter a Name', 'error');
//       return;
//     } else {
//       setloading(true);
//       await dispatch(
//         UpdateOneRegionData(id, {
//           name: regions,
//         }),
//       );
//       setloading(false);
//     }
//   };

//   const res_update = useSelector((state) => state.AllRegions.UpdateRegion);

//   useEffect(() => {
//     if (loading === false) {
//       if (res_update && res_update.data) {
//         Notify('success', 'Region Updated Successfully', 'success');
//         setregions('');
//       } else {
//         Notify('error', 'Error While Updating Region', 'error');
//         return;
//       }
//     }
//   }, [loading]);

//   // ==================================================================
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/Regionsandareas'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/Regionsandareas'
//         : '/'; // fallback

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col onSubmit={2}></Col>
//         <Col sm={10}>
//           {/* <div className='mx-4 d-flex'>
//             <div className='mx-3'>Regions</div>
//             <a style={{textDecoration:'none'}} href='/Regionsandareas' className='goback'>{"<<"} Go To Regions </a>
//         </div> */}

//           <div className="d-flex">
//             <div>
//               <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//                 <span style={{ fontWeight: 'bold' }}>Home Regions</span>
//               </Link>

//               <KeyboardDoubleArrowRightIcon />

//               <span style={{ color: '#666' }}>Regions</span>
//             </div>
//           </div>

//           <div
//             style={{
//               background: mode === 'dark' ? '#333' : '#fff',
//               borderRadius: '25px',
//               padding: '20px',
//             }}
//           >
//             {/* inputes of add Region */}
//             <Row>
//               <div style={{ marginTop: '20px' }}>
//                 <label for="Name">Regions Name</label>
//                 <input
//                   style={{ background: 'transparent', color: mode === 'dark' ? '#fff' : '#333' }}
//                   onChange={namechange}
//                   value={regions}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="Name"
//                   placeholder="Region Name.."
//                 />
//               </div>
//             </Row>

//             <div className="d-flex justify-content-center">
//               <div
//                 style={{ textAlign: 'center', background: '#102dff' }}
//                 onClick={updateregion}
//                 className="addnewclient"
//                 type="submit"
//               >
//                 <SyncAltIcon /> Update Regions
//               </div>
//             </div>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };











// 20-5-2026
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Notify } from '../../Utility/Notify';
import { GetOneRegionsData, UpdateOneRegionData } from '../../Redux/Actions/Regions_Action';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const UpdateRegions = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  /* ✅ sidebar sync */
  const sidebarWidth = useSidebarWidth();

  const [regions, setRegions] = useState('');
  const [loading, setLoading] = useState(true);
  // const [sending, setSending] = useState(false);

  /* ── get user role for breadcrumb ── */
  const [userlogin, setUserlogin] = useState(null);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) setUserlogin(user);
  }, []);

  const homeRoute = userlogin?.data?.role === 'Admin' || userlogin?.data?.role === 'Marketer'
    ? '/Regionsandareas'
    : '/';

  /* ── fetch existing region data ── */
  useEffect(() => {
    const fetchRegion = async () => {
      await dispatch(GetOneRegionsData(id));
    };
    fetchRegion();
  }, [dispatch, id]);

  const resGetOneRegion = useSelector((state) => state.AllRegions.Region);
  const OneRegion = resGetOneRegion?.data || null;

  useEffect(() => {
    if (OneRegion?.name) {
      setRegions(OneRegion.name);
    }
  }, [OneRegion]);

  /* ── submit update ── */
  const onSubmitUpdate = async (e) => {
    e.preventDefault();
    if (!regions.trim()) return Notify('error', 'Region name is required', 'error');
    setLoading(true);
    await dispatch(UpdateOneRegionData(id, { name: regions.trim() }));
    setLoading(false);
  };

  const resUpdate = useSelector((state) => state.AllRegions.UpdateRegion);

  useEffect(() => {
    if (loading === false && regions !== '') {
      if (resUpdate?.status === 200 || resUpdate?.data) {
        Notify('success', 'Region updated successfully', 'success');
        setTimeout(() => navigate(homeRoute), 1200);
      } else if (loading === false && regions !== '') {
        Notify('error', 'Failed to update Region', 'error');
      }
    }
  }, [loading, resUpdate, regions, homeRoute, navigate]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to={homeRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Regions
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Update Region</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
              Update Region
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Edit the region name in the CRM location database
            </p>
          </div>

          {/* field */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Region Name *</label>
            <input
              style={inputStyle}
              value={regions}
              onChange={(e) => setRegions(e.target.value)}
              type="text"
              placeholder="e.g. Downtown, Marina, JBR"
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={(e) => { if (e.key === 'Enter') onSubmitUpdate(e); }}
              autoFocus
            />
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full region name as it will appear across the system
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={onSubmitUpdate }
              disabled={!loading}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor:! loading ? 'not-allowed' : 'pointer',
                opacity:! loading ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { if (!loading) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; } }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              {!loading
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Updating…</span></>
                : <><SyncAltIcon sx={{ fontSize: 17 }} /><span>Update Region</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate(homeRoute)}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8'; e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b'; }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};